import { UpsellAnalyticsTotalsSnapshotSchema } from "@redotech/redo-analytics-common/analytics";
import * as z from "zod";

export const getUpsellAnalytics = {
  name: "getUpsellAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
    attributionDays: z.number().int().min(1).max(5).optional(),
  }),
  output: z.object({
    current: z.array(UpsellAnalyticsTotalsSnapshotSchema),
    previous: z.array(UpsellAnalyticsTotalsSnapshotSchema),
    totalCount: z.number().optional(),
  }),
};
